module.exports = __webpack_public_path__ + "../img/homepage/slider\\slide-1.jpg";